export const formasPago = Object.freeze({
    EFECTIVO: 1,
    TDC: 2,
    TDD: 3,
    TRANSFERENCIA: 4,
    MERCADOPAGO: 5,
    APLICARSALDO: 6,
    FINANCIAMIENTO: 7,
});